import English from "./locales/multiple-select-en-US.js";
const BLOCK_ROWS = 50;
const CLUSTER_BLOCKS = 4;
const noopFalse = () => false;
const noopTrue = () => true;
const DEFAULTS = {
  name: "",
  placeholder: "",
  classes: "",
  classPrefix: "",
  data: void 0,
  locale: void 0,
  selectAll: true,
  single: void 0,
  singleRadio: false,
  multiple: false,
  hideOptgroupCheckboxes: false,
  multipleWidth: 80,
  width: void 0,
  dropWidth: void 0,
  maxHeight: 250,
  maxHeightUnit: "px",
  position: "bottom",
  displayValues: false,
  displayTitle: false,
  displayDelimiter: ", ",
  minimumCountSelected: 3,
  ellipsis: false,
  isOpen: false,
  keepOpen: false,
  openOnHover: false,
  container: null,
  filter: false,
  filterGroup: false,
  filterPlaceholder: "",
  filterAcceptOnEnter: false,
  filterByDataLength: void 0,
  customFilter(filterOptions) {
    const { text, label, search } = filterOptions;
    return (label || text || "").includes(search);
  },
  showClear: false,
  // auto-position the drop
  autoAdjustDropHeight: false,
  autoAdjustDropPosition: false,
  autoAdjustDropWidthByTextSize: false,
  adjustedHeightPadding: 10,
  useSelectOptionLabel: false,
  useSelectOptionLabelToHtml: false,
  navigationHighlight: true,
  infiniteScroll: false,
  virtualScroll: true,
  cssStyler: () => null,
  textTemplate: (elm) => elm.innerHTML.trim(),
  labelTemplate: (elm) => elm.label,
  onBeforeOpen: noopFalse,
  onChange: noopFalse,
  onOpen: noopFalse,
  onBeforeClose: noopTrue,
  onClose: noopFalse,
  onCheckAll: noopFalse,
  onUncheckAll: noopFalse,
  onFocus: noopFalse,
  onBlur: noopFalse,
  onOptgroupClick: noopFalse,
  onBeforeClick: noopTrue,
  onClick: noopFalse,
  onFilter: noopFalse,
  onFilterClear: noopFalse,
  onClear: noopFalse,
  onAfterCreate: noopFalse,
  onDestroy: noopFalse,
  onAfterDestroy: noopFalse,
  onDestroyed: noopFalse
};
const METHODS = [
  "init",
  "getOptions",
  "refreshOptions",
  "getSelects",
  "setSelects",
  "enable",
  "disable",
  "open",
  "close",
  "check",
  "uncheck",
  "checkAll",
  "uncheckAll",
  "checkInvert",
  "focus",
  "blur",
  "refresh",
  "destroy"
];
Object.assign(DEFAULTS, English["en-US"]);
const Constants = {
  BLOCK_ROWS,
  CLUSTER_BLOCKS,
  DEFAULTS,
  METHODS
};
export default Constants;
